export default {"src":"/_next/static/media/icon_share_android.8cd909a0.svg","height":20,"width":18,"blurWidth":0,"blurHeight":0};